import { enGB } from "date-fns/locale";
// import { DatePickerCalendar, useDateInput } from "react-nice-dates";
// import "react-nice-dates/build/style.css";
import Input from "./Input";
import { format } from "date-fns";
import { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { CalendarPicker } from "@mui/x-date-pickers/CalendarPicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Grid, styled, TextField } from "@mui/material";
import { opacity } from "html2canvas/dist/types/css/property-descriptors/opacity";
import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";

// import * as muiStyles from "@mui/material/styles"
// or import specific members if needed, e.g.:
// import { makeStyles } from "@mui/material/styles"
interface Props {
  title: string;
  setDate: any;
  date?: any;
  defaultStartDate: any;
  defaultEndDate: any;
}

export default function SimpleDatePicker(props: Props) {
  const { title, date, setDate, defaultEndDate, defaultStartDate } = props;

  const [inputValue, setInputValue] = useState(date);
  const [isOutOfRange, setIsOutOfRange] = useState(false); // To track out-of-range dates

  // const handleInputChange = (
  //   input: React.ChangeEvent<HTMLInputElement> | Date | null
  // ) => {
  //   if (input instanceof Date || input === null) {
  //     // Case when the input is from DatePickerCalendar
  //     if (input) {
  //       const dateString = format(input, "YYYY-MM-DD");
  //       setInputValue(dateString);

  //       const isWithinRange =
  //         input >= new Date(defaultStartDate) &&
  //         input <= new Date(defaultEndDate);

  //       if (isWithinRange) {
  //         setDate(input); // Update only if within range
  //         setIsOutOfRange(false); // Clear any out-of-range flag
  //       } else {
  //         setIsOutOfRange(true); // Flag it as out-of-range
  //       }
  //     } else {
  //       setDate(null); // Clear date if null
  //       setInputValue("");
  //       setIsOutOfRange(false); // Reset out-of-range state
  //     }
  //   } else {
  //     const dateString = input.target.value;
  //     setInputValue(dateString); // Update the input value as the user types

  //     const isValidFormat = /^\d{4}-\d{2}-\d{2}$/.test(dateString);

  //     // Check if date is in valid format and is a valid date
  //     if (isValidFormat) {
  //       const parsedDate = new Date(dateString);
  //       const isValidDate = !isNaN(parsedDate.getTime());

  //       if (isValidDate) {
  //         const isWithinRange =
  //           parsedDate >= new Date(defaultStartDate) &&
  //           parsedDate <= new Date(defaultEndDate);

  //         if (isWithinRange) {
  //           setDate(parsedDate);
  //           setIsOutOfRange(false); // Date is valid and within range
  //         } else {
  //           setIsOutOfRange(true); // Date is out of the valid range
  //           setDate(null);
  //         }
  //       } else {
  //         // Invalid date (e.g., 2024-01-ab)
  //         setIsOutOfRange(true);
  //         setDate(null);
  //       }
  //     } else {
  //       // Invalid format (not YYYY-MM-DD)
  //       setIsOutOfRange(true);
  //       setDate(null);
  //     }

  //     if (dateString === "") {
  //       setDate(null); // Clear date if empty input
  //       setIsOutOfRange(false); // Reset out-of-range
  //     }
  //   }
  // };

  const CustomCalendarPicker = styled(CalendarPicker)(({ theme }) => ({
    // backgroundColor: "#222",
    color: "#fff",
    width: "100%",
    height: "100%",
    // paddingBottom: 20, // or more
    paddingBottom: 40,

    "& .MuiPickersDay-root": {
      color: "#fff",
      background: "none",
      width: 50, // Increase day cell width
      height: 50, // Increase day cell height
      minWidth: 50, // Important to override default
      fontSize: "1rem",
    },

    "& .PrivatePickersSlideTransition-root.MuiDayPicker-slideTransition": {
      overflowX: "visible", // or "auto" if you want scroll
    },

    "& .MuiDayPicker-weekDayLabel": {
      width: 50, // Increase day cell width
      height: 50, // Increase day cell height
      minWidth: 50, // Important to override default
      fontSize: "1rem",
      color: "white",
      opacity: 0.8,
      fontWeight: "bold",
    },

    "& .MuiDayPicker-weekDayLabel:nth-of-type(1)::after": {
      content: '"un"',
    },
    "& .MuiDayPicker-weekDayLabel:nth-of-type(2)::after": {
      content: '"on"',
    },
    "& .MuiDayPicker-weekDayLabel:nth-of-type(3)::after": {
      content: '"ue"',
    },
    "& .MuiDayPicker-weekDayLabel:nth-of-type(4)::after": {
      content: '"ed"',
    },
    "& .MuiDayPicker-weekDayLabel:nth-of-type(5)::after": {
      content: '"hu"',
    },
    "& .MuiDayPicker-weekDayLabel:nth-of-type(6)::after": {
      content: '"ri"',
    },
    "& .MuiDayPicker-weekDayLabel:nth-of-type(7)::after": {
      content: '"at"',
    },

    "& .MuiPickersArrowSwitcher-root svg": {
      fill: "#fff", // or use color: '#fff' depending on icon
    },
    // Disabled arrows (grayed out)
    "& .MuiPickersArrowSwitcher-root.Mui-disabled svg": {
      fill: "gray", // or any gray color you want
      opacity: 0.1,
      cursor: "default", // optional, show pointer only when enabled
    },

    "& .Mui-selected": {
      backgroundColor: "#1976d2",
      color: "#fff",
    },

    "& .MuiPickersCalendarHeader-root": {
      color: "white",
    },
    "& .MuiPickersDay-root.Mui-disabled": {
      color: "gray",
      opacity: 0.5,
    },
  }));

  return (
    <div
      style={{
        border: "1px solid #181818",
        boxShadow: "0px 0px 4px black",
        padding: 15,
        borderRadius: 10,
        background: "#2121212b",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 15,
          fontWeight: "bold",
        }}
      >
        {title}
        <div style={{ position: "relative" }}>
          {isOutOfRange && (
            <>
              <span
                style={{
                  fontSize: 12,
                  position: "absolute",
                  top: -25,
                  color: "orange",
                  width: "350px",
                }}
              >
                {/* <Icon
                  sx={{
                    // color: "#ffff86",
                    mr: 1,
                    textShadow: "0 1px 5px black",
                  }}
                >
                  psychology
                </Icon> */}
                Must between{" "}
                {dayjs(new Date(defaultStartDate)).format("YYYY-MM-DD")} and{" "}
                {defaultEndDate}
              </span>
            </>
          )}
          <Input
            value={dayjs(inputValue).format("YYYY-MM-DD") || ""}
            id="calendar-input"
            name="searchInput"
            // placeholder="Search competencies..."
            style={{
              width: "inherit",
              color: "white",
              padding: "10px 20px",
              cursor: "pointer",
            }}
            color="white"
            className="input"
            maxLength={10}
            readOnly
            // onChange={(e: any) => handleInputChange(e)}
          />
        </div>
      </div>
      <div
        style={{
          background: "rgba(171, 171, 171, 0.15)",
          borderRadius: 5,
          minHeight: 300,
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CustomCalendarPicker
            views={["day"]}
            date={date ? dayjs(date) : null}
            // date={date}
            onChange={(newValue: any) => {
              setDate(newValue);
              setInputValue(newValue ? newValue : "");
              setIsOutOfRange(
                newValue
                  ? newValue.isBefore(dayjs(defaultStartDate)) ||
                      newValue.isAfter(dayjs(defaultEndDate))
                  : false
              );
            }}
            minDate={dayjs(defaultStartDate)}
            maxDate={dayjs(defaultEndDate)}
            // renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        {/* <DatePickerCalendar
          minimumDate={new Date(defaultStartDate)}
          maximumDate={new Date(defaultEndDate)}
          date={new Date(date)}
          onDateChange={(date) => handleInputChange(date)} // Handles calendar date changes
          locale={enGB}
        /> */}
      </div>
    </div>
  );
}
